export default __webpack_public_path__ + "static/media/CNo.37-0.c835d393.jpg";